import { UserPerformanceFilterI } from "shared/lib/interfaces/performance";

export const PERFORMANCE_DASHBOARD_QUERY_KEY =
  "PERFORMANCE_DASHBOARD_QUERY_KEY";

export const PERFORMANCE_CAMPAIGN_STATS_QUERY_KEY =
  "PERFORMANCE_CAMPAIGN_STATS_QUERY_KEY";

export const PERFORMANCE_REVENUE_QUERY_KEY = "performance_revenue";

export const TODAY_PERFORMANCE_QUERY_KEY = "today_performance";

export const LIFETIME_PERFORMANCE_QUERY_KEY = "lifetime_performance";

export const GOAL_TRACKER_PROGRESS_QUERY_KEY = "goal_tracker_progress";

export const PerformanceDashboardQueryKeys = {
  dashboardMetrics: (
    filters: UserPerformanceFilterI | undefined,
    campaignId: string | undefined
  ) => [PERFORMANCE_DASHBOARD_QUERY_KEY, filters, campaignId],
  revenue: (filters: UserPerformanceFilterI | undefined) => [
    PERFORMANCE_REVENUE_QUERY_KEY,
    filters,
  ],
  campaignStats: (campaignId: string | undefined) => [
    PERFORMANCE_CAMPAIGN_STATS_QUERY_KEY,
    campaignId,
  ],
  lifetimePerformance: () => [LIFETIME_PERFORMANCE_QUERY_KEY],
  todayPerformance: () => [TODAY_PERFORMANCE_QUERY_KEY],
  callCoachingByCampaign: (campaignId: string | undefined) => [
    PERFORMANCE_CAMPAIGN_STATS_QUERY_KEY,
    "coaching",
    campaignId,
  ],
  goalTrackerProgress: () => [GOAL_TRACKER_PROGRESS_QUERY_KEY],
  performanceChartData: (campaignIds: string[]) => [
    PERFORMANCE_DASHBOARD_QUERY_KEY,
    campaignIds,
  ],
};
